import { useState, useEffect } from 'react';
import { Footer } from "components";

const SIDEBAR_KEY = 'cpay-client-sidebar';

function Main({ children }) {
    const [expanded, setExpanded] = useState(() => {
        const saved = localStorage.getItem(SIDEBAR_KEY);
        return saved === null ? true : saved === 'true';
    });

    useEffect(() => {
        const handler = () => setExpanded(e => !e);
        window.addEventListener('toggle-sidebar', handler);
        return () => window.removeEventListener('toggle-sidebar', handler);
    }, []);

    return (
        <div
            id='main-content'
            aria-label='Main Content'
            className={`overflow-y-auto w-full h-full relative transition-all duration-200 ${expanded ? 'lg:ml-56' : 'lg:ml-14'}`}
        >
            <div className='py-4 px-4 md:px-6'>
                {children}
                <Footer />
            </div>
        </div>
    );
}

export default Main;
